/**
 * Created by mykurisu on 2017/6/26.
 */
import React from 'react'
import {connect} from 'react-redux'
import {Mask} from 'react-weui'
import config from '../../config'
import '../../styles/liveroom/LiveroomQrcode.css'

class LiveroomQrcode extends React.Component {

    constructor() {
        super();
        this.handleQrcodeHide = this.handleQrcodeHide.bind(this);
    }

    componentDidMount() {
        let code = this.refs.customQrcode;
        code.addEventListener('click', function (e) {
            e.stopPropagation();
        });
    }

    handleQrcodeHide() {
        this.props.dispatch({
            type: 'LIVEROOM_QRCODE_HIDE'
        })
    }

    render() {
        const {custom_qrcode_url, is_manager} = this.props;
        return (
            <div className="liveroom-page-container">
                <Mask className="liveroom-qrcode-mask" onClick={this.handleQrcodeHide}>
                    <div className="liveroom-qrcode-codearea" ref="customQrcode">
                        <img src={custom_qrcode_url} alt=""/>
                        {is_manager &&
                        <p className="pc-description">
                            电脑浏览器打开讲师管理后台<br/>
                            进入直播间管理，即可上传公众号二维码<br/>
                            （{config.ADMIN_BASE_URL}）
                        </p>
                        }
                    </div>
                </Mask>
            </div>
        )
    }
}

export default connect(state => ({
    qrcodeShow: state.liveroom.qrcodeShow,
    custom_qrcode_url: state.liveroom.liveroom.custom_qrcode_url,
    is_manager: state.liveroom.role.is_manager,
}))(LiveroomQrcode)



// WEBPACK FOOTER //
// ./src/components/liveroom/LiveroomQrcode.js